import React from "react";
import MaterialTable from "material-table";

function TableBusiness({ handleClickOpen, handleDelete, entries }) {
  return (
    <MaterialTable
      localization={{
        pagination: {
          labelDisplayedRows: "{from}-{to} de {count}",
          labelRowsPerPage: "Filas por página",
          labelRowsSelect: "Filas",
          firstAriaLabel: "Primera página",
          firstTooltip: "Primera página",
          previousAriaLabel: "Página anterior",
          previousTooltip: "Página anterior",
          nextAriaLabel: "Próxima página",
          nextTooltip: "Próxima página",
          lastAriaLabel: "Última página",
          lastTooltip: "Última página",
        },
        toolbar: {
          nRowsSelected: "{0} filas(s) seleccionadas",
          searchTooltip: "Buscar",
          searchPlaceholder: "Buscar",
        },
        header: {
          actions: "Acciones",
        },
        body: {
          emptyDataSourceMessage: "No hay comercios para mostrar",
          deleteTooltip: "Eliminar",
          editTooltip: "Editar",
          filterRow: {
            filterTooltip: "Filtrar",
          },
          editRow: {
            saveTooltip: "Guardar",
            cancelTooltip: "Cancelar",
            deleteText: "¿Está seguro que desea eliminar el comercio?",
          },
        },
      }}
      actions={[
        {
          icon: "edit",
          tooltip: "Editar",
          onClick: (event, rowData) => handleClickOpen(event, rowData),
        },
        {
          icon: "add",
          tooltip: "Agregar comercio",
          isFreeAction: true,
          onClick: (event) => handleClickOpen(event),
        },
      ]}
      title="Comercios"
      columns={[
        { title: "Nombre", field: "name" },
        { title: "Dirección", field: "address" },
      ]}
      data={entries.data}
      editable={{
        onRowDelete: (oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              handleDelete(oldData);
            }, 600);
          }),
      }}
    />
  );
}

export default React.memo(TableBusiness);
